export const API_BACKEND_ENDPOINT = process.env.NX_API_BACKEND ?? ''
export const COOKIE_DOMAIN = process.env.NX_COOKIE_DOMAIN ?? ''
export const NX_AUTH_REDIRECT_CACHE_TIME = parseInt(process.env.NX_AUTH_REDIRECT_CACHE_TIME ?? '500')
export const NX_INTERCOM_ID = process.env.NX_INTERCOM_ID ?? ''
export const NX_PIXEL_ID = process.env.NX_PIXEL_ID ?? ''